import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { Reveal, Chapter } from './motion';

export default function FAQSection({ faqs, heading = 'Frequently Asked Questions', chapterNum, idPrefix = 'faq' }) {
  if (!faqs?.length) return null;
  return (
    <section className="bg-white py-16 lg:py-24" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-12">
        <Reveal>
          {chapterNum && <div className="mb-4"><Chapter num={chapterNum} label="Common Questions" /></div>}
          <h2 className="font-display text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl">{heading}</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-8">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-slate-200">
                <AccordionTrigger
                  data-testid={`${idPrefix}-question-${i}`}
                  className="text-left font-display text-base font-semibold text-navy hover:text-brand sm:text-lg"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-base leading-relaxed text-slate-600" data-testid={`${idPrefix}-answer-${i}`}>
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
